/**
 * Путь к фото руководителя в интервью.
 *
 * В шаблоне это `/media/photo/interview/<id>.jpg`; `/media/` отдаётся как есть.
 */
export default function getInterviewPhotoUrl(interviewId: number | undefined): string {
  if (!interviewId) {
    return ''
  }

  return `/media/photo/interview/${interviewId}.jpg`
}
